module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="celebrity-popup-overlay">\n	<div class="celebrity-popup-inner">\n		<header class="celebrity-popup-header player-cell-btns">\n			<h5>Add Celebrity Teams</h5>\n			<a class="icon-close js-close">\n				Cancel\n			</a>\n		</header>\n		<section class="celebrity-popup-body">\n			';
 if(teams.length) { 
__p+='\n				';
 _.each( teams, function(team) { 
__p+='\n					<div class="team">\n						<picture>\n							<source srcset="'+
((__t=( process.env.AVATARS_PATH + team.user_id ))==null?'':_.escape(__t))+
'.png" type="image/png">\n							<img src="/assets/images/test-avatar.png?v=1" alt="">\n						</picture>\n						<div class="team-info">\n							<p class="team-name">'+
((__t=( team.name ))==null?'':_.escape(__t))+
'</p>\n							<p class="user-name">'+
((__t=( team.firstname ))==null?'':_.escape(__t))+
' '+
((__t=( team.lastname ))==null?'':_.escape(__t))+
'</p>\n						</div>\n						<div class="team-select">\n							<div class="checkbox-block">\n								<input type="checkbox" id="checkbox_'+
((__t=( team.user_id ))==null?'':_.escape(__t))+
'" class="js-team-select" value="'+
((__t=( team.user_id ))==null?'':_.escape(__t))+
'" />\n								<label for="checkbox_'+
((__t=( team.user_id ))==null?'':_.escape(__t))+
'" class="ion-checkmark-round"></label>\n							</div>\n						</div>\n					</div>\n				';
 }); 
__p+='\n			';
 }else { 
__p+='\n				<div class="team">Celebrity teams not found</div>\n			';
 } 
__p+='\n		</section>\n		<section>\n			<a href="javascript:void(0)" class="base-btn primary-btn js-add-selection-teams disable">Add selection</a>\n		</section>\n	</div>\n</div>';
}
return __p;
};
